<template>

  <v-tooltip 
    right 
    :color="color" 
    content-class="caption" 
    transition="slide-x-transition"
    v-if="makePersonMatch"
  >
    <template v-slot:activator="{ on }">
      <span v-on="on" @click="showing">
        <reason 
          compressed
          :row-type="targetType"
          :reason = "makePersonMatch"
          :clickable="false"
          hideTip
          emit="selected"
          @selected="showing"
        > 
        </reason>
      </span>
    </template>

    <v-card flat :color="color">
      <person-tipper
        :item="matchingRow"
        :makePersonMatch="makePersonMatch"
      ></person-tipper>

    </v-card>

  </v-tooltip>
</template>

<script>
import Persontipper from '@/components/Persontipper'
import Reason from '@/components/Reason'
import { getIconColor } from '@/js/store'

export default {
  props: {
    matchingRow: Object,
    makePersonMatch: Object,
    targetType: String
  },
  components: {
    'reason': Reason,
    'person-tipper': Persontipper
  },
  methods: {
    showing () {
      this.showEmit (true)
    },
    showEmit (b) {
      this.$emit('showing', b ? this.matchingRow : null)
    }
  },
  computed: {
    color () {
      return getIconColor(this.targetType)
    }
  }
}
</script>
